import { useContext } from "react";
import { CircleLoader, PageHeader } from "components";
import { Filter, Results } from './components';
import { toolsContext } from './ToolsContext';


let WorkLogs = () => {
    let service = useContext(toolsContext);


    return (
        <>
            <PageHeader pageTitle={"Strumenti"} addNewUrl={`/tool/addnew/`} />
            <Filter />
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false && <Results />}
        </>
    );
}

export default WorkLogs;